import Button, { ButtonProps } from '@/components/Button'
import FileListModal from '@/components/modals/FileListModal'
import { t } from 'i18next'
import React from 'react'
interface FileListButtonProps extends Omit<ButtonProps, 'onClick'> {
  contextType: 'customer' | 'deal' | 'car' | 'report' | 'user'
  contextId: string | number
  title?: string
  onFileDelete?: () => void
}

const FileListButton: React.FC<FileListButtonProps> = ({
  contextType,
  contextId,
  title = t('view_files'),
  onFileDelete,
  ...buttonProps
}) => {
  const [isModalOpen, setIsModalOpen] = React.useState(false)
  return (
    <>
      <Button
        onClick={() => setIsModalOpen(true)}
        className="main-btn outline white"
        title={title}
        {...buttonProps}
      >
        {title}
      </Button>

      <FileListModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        contextType={contextType}
        contextId={contextId}
        onFileDelete={onFileDelete}
      />
    </>
  )
}

export default FileListButton 